import { RoutesPaths } from "../../../constants/routes"
import { calendarDeepLink } from "../../Calendar/helpers/calendar-deep-link.ts"
import { NOTIFICATION_TYPE, type Notification } from "../types/notification.types.ts"

/** Where clicking a notification opens, or null when it opens nothing. */
export function notificationHref(notification: Notification): string | null {
  const target = notification?.target

  // Its target is the lead's Project row, which the generic case below would
  // open as a project overview. The lead Files tab has no folder view, so the
  // tab itself is where the From Customer files are.
  if (
    Number(notification?.notification_name) ===
    NOTIFICATION_TYPE.LEAD_CUSTOMER_UPLOADED_FILES
  ) {
    const leadId = notification.data?.lead_id || target?.id
    if (leadId)
      return notification.data?.is_project
        ? RoutesPaths.project.view(leadId).files()
        : RoutesPaths.lead.view(leadId, { tab: "files" })
  }

  switch (target?.type) {
    case "project":
      return RoutesPaths.project.view(target.id).overview
    case "lead":
      return RoutesPaths.lead.view(target.id)
    case "calendarevent":
      return calendarDeepLink(undefined, notification.data?.event_id || target.id)
    case "subcontractor":
      return RoutesPaths.subcontractors.view(target.id)
    default:
      return null
  }
}
